// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"236":"680ad001c2cf1978eb95","953":"9e3d11ca96fc15090f76"}[chunkId] + ".css";
};